<div [class]="field.styleValue" [attr.lang]="metadataValue.language">
  <span [innerHTML]="processHtml(metadataValue.value)" class="text-value"></span>
</div>
